import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {fieldsTypes, notificationTypes, route} from "../../config/constants";
import {useTranslation, withTranslation} from 'react-i18next';
import { withRouter } from 'react-router-dom';
import RaisedButton from "material-ui/RaisedButton";
import { AutoSizer } from "react-virtualized";
import ScrollableTable from "../ScrollableTable/ScrollableTable";
import IconButton from "material-ui/IconButton";
import { ActionDelete } from "material-ui/svg-icons";
import Preloader from "../Preloader/Preloader";
import {getListOfNotifications, setActiveNotifications} from "store/actions/notifications";
import './style.css';
import DeleteNotificationPopup from "./Components/DeleteNotificationPopup";
import NotificationsEmptyState from "./NotificationsEmptyState";
import {FETCHING_STATUS, FETCHING_TYPE} from "../../store/reducers/notifications";
import { showNotification } from 'store/actions/notification';
import theme from "../SlateViews/theme";

const MaterialSymbol = ({ name, style = {}, className = '' }) => (
  <span className={`material-symbols-outlined ${className}`} style={style}>{name}</span>
);

const Notifications = ({
                         history,
                         getListOfNotifications,
                         setActiveNotifications,
                         notificationsList: notificationsListProps,
                         currentAccount,
                         isFetching,
                         showNotification,
                 }) => {
  const { t } = useTranslation();
  const columns = [
    {
      index: 0,
      name: t('notificationsPage:tableTitles:name'),
      type: fieldsTypes.TEXT,
      width: 300,
    },
    {
      index: 1,
      name: t('notificationsPage:tableTitles:triggerType'),
      type: fieldsTypes.TEXT,
      width: 300,
    },
    {
      index: 2,
      name: t('notificationsPage:tableTitles:deliveryType'),
      type: fieldsTypes.TEXT,
    },
    // {
    //   index: 3,
    //   name: t('notificationsPage:tableTitles:actions'),
    //   type: fieldsTypes.ACTIONS,
    // },
  ]
  const [notificationsList, setNotificationsList] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const actionButtons = (data) => <div className="apikey-item-actions">
    <IconButton
      data-id={data}
      onClick={(e) => {
        e.stopPropagation();
        setActiveNotifications(data);
        setOpenPopup(true);
      }}
    >
      <ActionDelete />
    </IconButton>
  </div>

  useEffect(() => {
    if(!notificationsListProps && currentAccount) getListOfNotifications();
  }, []);

  const editNotification = (e, UUID) => {
    // Use notificationsListProps (original data) to check trigger type, not the localized list
    const notification = notificationsListProps.find(element => element.uuid === UUID);
    if (notification && (notification.columns[1].value === 'dateField' || notification.columns[1].value === 'dateFieldReminder')) {
      setActiveNotifications(UUID);
      history.push({
        pathname: route.NOTIFICATIONS + '/' + UUID,
      });
    } else {
      showNotification(
        notificationTypes.WARNING,
        t('notifications:notificationMustBeConfiguredBySlatePages'),
      );
    }
  }

  useEffect(() => {
    if(currentAccount) getListOfNotifications();
  }, [currentAccount && currentAccount.uuid]);

  // Map trigger type values to localized strings
  const localizeTriggerType = (value) => {
    if (value === 'slateChanges') return t('notificationsPage:triggerTypes:slateChanges');
    if (value === 'dateField' || value === 'dateFieldReminder') return t('notificationsPage:triggerTypes:dateField');
    return value;
  };

  // Map delivery type values to localized strings
  const localizeDeliveryType = (value) => {
    if (value === 'email') return t('notificationsPage:deliveryTypes:email');
    if (value === 'webhook') return t('notificationsPage:deliveryTypes:webhook');
    return value;
  };

  useEffect(() => {
    if(!notificationsListProps) return;
    const newNotificationsList = notificationsListProps.map( notification => {
      // Localize trigger type and delivery type columns
      var localizedColumns = notification.columns.map(function(col) {
        if (col.index === 1) {
          return { ...col, value: localizeTriggerType(col.value) };
        }
        if (col.index === 2) {
          return { ...col, value: localizeDeliveryType(col.value) };
        }
        return col;
      });
      return {
        ...notification,
        columns: [...localizedColumns, {value: actionButtons(notification.uuid), index: localizedColumns.length}]
      }
    })

    setNotificationsList(newNotificationsList)
  }, [notificationsListProps, t]);

  const createNewNotification = () => {
    history.push({
      pathname: route.NOTIFICATIONS_NEW,
    });
  }

  const closePopup = () => {
    setActiveNotifications('');
    setOpenPopup(false);
  }

  const handleRefreshClick = () => {
    getListOfNotifications();
  };

  const getRowHeight = ({ index }) => {
    return (notificationsList[index].columns[3].value.length || 1) * 36
  }

  return (
    notificationsList ?
    <div className="inner-page table-page-layout notifications-page">
      <div className="notifications-header">
        <h1 className="notifications-header-title">{t('notificationsPage:title')}</h1>
        <div className="notifications-header-actions">
          <RaisedButton
            icon={<MaterialSymbol name="refresh" style={{...theme.slateViewActionIconStyle, fontSize: 22}} />}
            style={theme.slateViewActionStyle}
            onClick={handleRefreshClick}
          />
          <button
            type="button"
            className="notifications-header-action"
            onClick={createNewNotification}
          >
            <span className="material-symbols-outlined">add</span>
            {t('notificationsPage:addNotificationButton')}
          </button>
        </div>
      </div>
      <div className="table-page-content">
        <div className="table-page-content-inner">
        {
          (
            isFetching.status === FETCHING_STATUS.inProgress &&
            isFetching.type === FETCHING_TYPE.gettingNotificationsList
          ) ?
            <Preloader /> :
            notificationsList.length === 0 ?
              <NotificationsEmptyState t={t} onCreateNew={createNewNotification} /> :
              <AutoSizer>
                {({ width, height }) => (
                  <ScrollableTable
                    onRowClickParentHandler={editNotification}
                    columns={columns}
                    data={notificationsList}
                    isExpandable={false}
                    fixedHeader={true}
                    fixedHeaderHeight={36}
                    useDragHandle={true}
                    withOrdering={false}
                    withFiltration={false}
                    withSorting={true}
                    uniqueField="uuid"
                    widthStretch={true}
                    width={width}
                    height={height}
                    fetchData={() => {}}
                    rowHeightPreset={getRowHeight}
                  />
                )}
              </AutoSizer>
        }
        </div>
      </div>
      <DeleteNotificationPopup
        open={openPopup}
        closePopup={closePopup}
        currentAccountUUID={currentAccount.uuid}
      />
    </div> :
      <Preloader />
  );
};

const mapStateToProps = (state) => ({
  currentAccount: state.accounts.currentAccount,
  notificationsList: state.notifications_page.listOfNotifications,
  isFetching: state.notifications_page.isFetching,
});

const mapDispatchToProps = {
  getListOfNotifications,
  setActiveNotifications,
  showNotification,
};


export default withRouter(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(Notifications),
  ),
);
